import React, { useEffect, useState } from 'react';
// import './BrowserHeader.scss';
import styles from './BrowserHeader.module.scss';
import Button from '@components/Button';
import { DatePicker, DateRangePicker } from '@components/DatePicker/DatePicker';
import Input from '@components/Input';
import { StudyFilter } from 'config/studyConfig';
import { ReactComponent as Refresh } from 'img/header-refresh.svg';
import MultiSelectDropdown, {
  Option,
} from '@components/MultiSelectDropdown/MultiSelectDropdown';
import { Status } from '@models/Study';

interface BrowserHeaderProps {
  handleClickRefresh: () => void;
  handleClickQuery: (value: Partial<StudyFilter>) => void;
  columnOptions: Option[];
  onChangeColumns: (options: Option[]) => void;
}

const statusList: Status[] = [
  'Pending',
  'Processing',
  'PartialComplete',
  'Complete',
  'Confirmed',
  'Failed',
];

const BrowserHeader: React.FC<BrowserHeaderProps> = ({
  handleClickRefresh,
  handleClickQuery,
  columnOptions,
  onChangeColumns,
}: BrowserHeaderProps) => {
  // Filter Options
  const [birthdateFilter, setBirthdateFilter] = useState<string | null>(null);
  const [searchValue, setsearchValue] = useState<string>('');
  const [searchPatientID, setSearchPatientID] = useState<string>('');
  const [searchPatientName, setSearchPatientName] = useState<string>('');

  const [dateRange, setDateRange] = useState<{
    startDate: string | null;
    endDate: string | null;
  }>({ startDate: null, endDate: null });

  const [Status, setStatus] = useState<Option[]>(
    statusList.map((status, idx) => ({
      value: idx + 1,
      label: status,
      isSelected: false,
    })),
  );

  const onSearch = () => {
    const { startDate, endDate } = dateRange;

    const selectedStatuses = Status.filter((option) => option.isSelected).map(
      (option) => option.label,
    );

    const formatDate = (date?: string | null) =>
      date ? date.replace(/-/g, '') : undefined;

    const formattedBirthdate = formatDate(birthdateFilter);
    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    handleClickQuery({
      startDate: formattedStartDate ?? undefined,
      endDate: formattedEndDate ?? undefined,
      statuses: selectedStatuses.length
        ? selectedStatuses.join(',')
        : undefined,
      patient_birthdate: formattedBirthdate ?? undefined,
      study_description: searchValue ?? undefined,
      patientId: searchPatientID ?? undefined,
      patient_name: searchPatientName ?? undefined,
    });
  };

  useEffect(() => {
    onSearch();
  }, [dateRange, birthdateFilter, Status]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      onSearch();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchValue, searchPatientID, searchPatientName]);

  return (
    // <div className={styles.container}>
    <div className={styles.content}>
      <div className={styles.select}>
        <span className={styles.placeholder}>Study Date</span>
        <DateRangePicker value={dateRange} onChange={setDateRange} />
      </div>
      <div className={styles.select}>
        <span className={styles.placeholder}>Status</span>
        <MultiSelectDropdown
          options={Status}
          onChange={setStatus}
          placeholder="Select an option"
        />
      </div>
      {/* 바뀔 수도 있음  */}
      {/* <div className="left-section-status">
          <div>
            Analyst
          </div>
          <MultiSelectDropdown
            options={Analyst}
            onChange={setAnalyst}
            placeholder="Select an option"
          />
        </div> */}
      <div className={styles.select}>
        <span className={styles.placeholder}>BirthDate</span>
        <DatePicker value={birthdateFilter} onChange={setBirthdateFilter} />
      </div>

      <div className={styles.select}>
        <span className={styles.placeholder}>Patient ID</span>
        <Input
          className="browser-search-patient"
          type="search"
          value={searchPatientID}
          placeholder="Search"
          onChange={(e: any) => setSearchPatientID(e.target.value)}
        />
      </div>

      <div className={styles.select}>
        <span className={styles.placeholder}>Patient Name</span>
        <Input
          className="browser-search-patient"
          type="search"
          value={searchPatientName}
          placeholder="Search"
          onChange={(e: any) => setSearchPatientName(e.target.value)}
        />
      </div>

      <div className={styles.select}>
        <span className={styles.placeholder}>Description</span>
        <Input
          className="browser-search"
          type="search"
          value={searchValue}
          placeholder="Search"
          onChange={(e: any) => setsearchValue(e.target.value)}
        />
      </div>

      <div className={styles.columnsSelect}>
        <span className={styles.placeholder}>Columns</span>
        <MultiSelectDropdown
          className={styles.columnsDropdown}
          options={columnOptions}
          onChange={onChangeColumns}
          placeholder="Select columns"
        />
      </div>

      <div className={styles.container} />
      <Button
        className="browser-button"
        startIcon={<Refresh className={styles.iconRotation} />}
        type="button"
        onClick={handleClickRefresh}
      >
        Refresh
      </Button>
    </div>
    // </div>
  );
};

export default BrowserHeader;
